export function startTimer({ start, end, repeat = 'N', el = null, onUpdate = null }) {
    if (repeat !== 'Y' || !start || !end) return;

    const [sh, sm] = start.split(':').map(Number);
    const [eh, em] = end.split(':').map(Number);

    const startTime = new Date();
    startTime.setHours(sh, sm, 0, 0);

    const endTime = new Date();
    endTime.setHours(eh, em, 0, 0);
    if (endTime <= startTime) endTime.setDate(endTime.getDate() + 1);

    function getTimeStr() {
        const now = new Date();
        if (now < startTime || now > endTime) return '00:00:00';

        const diff = endTime - now;
        const h = String(Math.floor(diff / 1000 / 60 / 60)).padStart(2, '0');
        const m = String(Math.floor((diff / 1000 / 60) % 60)).padStart(2, '0');
        const s = String(Math.floor((diff / 1000) % 60)).padStart(2, '0');
        return `${h}:${m}:${s}`;
    }

    function updateAll() {
        const str = getTimeStr();

        if (typeof onUpdate === 'function') onUpdate(str);

        if (el) {
            const elements = typeof el === 'string' ? document.querySelectorAll(el) : [el];
            elements.forEach(elem => elem.textContent = str);
        }
    }

    updateAll();
    return setInterval(updateAll, 1000);
}
